/**
 * Custom error types for Orgo SDK
 */

export class OrgoError extends Error {
    constructor(message: string) {
      super(message);
      this.name = 'OrgoError';
      Object.setPrototypeOf(this, OrgoError.prototype);
    }
  }
  
  export class ApiError extends OrgoError {
    public statusCode?: number;
    public response?: unknown;
  
    constructor(message: string, statusCode?: number, response?: unknown) {
      super(message);
      this.name = 'ApiError';
      this.statusCode = statusCode;
      this.response = response;
      Object.setPrototypeOf(this, ApiError.prototype);
    }
  }
  
  export class ConfigError extends OrgoError {
    constructor(message: string) {
      super(message);
      this.name = 'ConfigError';
      Object.setPrototypeOf(this, ConfigError.prototype);
    }
  }